export const detailedServicesData = [
  {
    id: 1,
    slug: 'ikinci-el-bilgisayar-alim',
    icon: 'ri-shopping-cart-line',
    title: '2. El Bilgisayar Alım',
    shortDesc: 'Kullanılmış bilgisayarınızı en uygun fiyata değerlendiriyoruz',
    description: 'Eski bilgisayarınızı satmak mı istiyorsunuz? ES Bilgisayar olarak tüm marka ve modellerde 2. el bilgisayar alışı yapıyoruz. Laptop, masaüstü bilgisayar, oyuncu bilgisayarı ve iş istasyonları için adil fiyat teklifi sunuyoruz. Ücretsiz değerlendirme hizmeti ile cihazınızın gerçek değerini öğrenin.',
    features: [
      'Tüm marka ve modellerde alım',
      'Ücretsiz ön değerlendirme',
      'Anında nakit ödeme',
      'Adil ve şeffaf fiyatlandırma',
      'Veri güvenliği garantisi',
      'Hızlı işlem süreci',
    ],
    image: 'https://public.readdy.ai/ai/img_res/4040bc0d0eed94bfa5dfe8923ffeaab2.jpg',
  },
  {
    id: 2,
    slug: 'ikinci-el-bilgisayar-satis',
    icon: 'ri-computer-line',
    title: '2. El Bilgisayar Satış',
    shortDesc: 'Garantili ve test edilmiş ikinci el bilgisayar seçenekleri',
    description: 'Uygun fiyatlı ikinci el bilgisayar mı arıyorsunuz? Geniş ürün yelpazemizde sıfır ayarında 2. el laptop ve masaüstü bilgisayar modellerini bulabilirsiniz. Tüm ürünlerimiz detaylı testlerden geçer ve garanti ile teslim edilir. İkinci el bilgisayar alımında güvenilir adres.',
    features: [
      'Sıfır ayarında ürünler',
      'Detaylı test ve kontrol',
      '12 ay garanti',
      'Geniş ürün yelpazesi',
      'Uygun fiyat seçenekleri',
      'Taksit imkanı',
    ],
    image: 'https://readdy.ai/api/search-image?query=display%20of%20refurbished%20laptops%20and%20desktop%20computers%20on%20clean%20white%20shelves%20in%20modern%20tech%20store%20organized%20product%20showcase%20price%20tags%20visible%20professional%20retail%20environment%20bright%20lighting&width=600&height=400&seq=serv2&orientation=landscape',
  },
  {
    id: 3,
    slug: 'bilgisayar-tamiri',
    icon: 'ri-tools-line',
    title: 'Bilgisayar Tamiri',
    shortDesc: 'Profesyonel ve hızlı bilgisayar tamir hizmeti',
    description: 'Bilgisayarınız mı arızalandı? Masaüstü bilgisayar tamiri konusunda uzman ekibimiz tüm donanımsal ve yazılımsal sorunlara çözüm üretiyor. Anakart tamiri, ekran değişimi, güç kaynağı değişimi ve tüm bilgisayar bakım hizmetlerinde yanınızdayız.',
    features: [
      'Ücretsiz arıza tespiti',
      'Aynı gün tamir imkanı',
      'Orijinal parça kullanımı',
      '12 ay servis garantisi',
      'Uygun fiyat garantisi',
      'Deneyimli teknisyen kadrosu',
    ],
    image: 'https://readdy.ai/api/search-image?query=computer%20technician%20repairing%20desktop%20PC%20motherboard%20with%20precision%20tools%20on%20clean%20workbench%20close%20up%20technical%20work%20professional%20repair%20shop%20bright%20lighting%20commercial%20quality&width=600&height=400&seq=serv3&orientation=landscape',
  },
  {
    id: 4,
    slug: 'laptop-tamiri',
    icon: 'ri-macbook-line',
    title: 'Laptop Tamiri',
    shortDesc: 'Tüm marka laptop ve notebook tamiri',
    description: 'Laptop tamiri ve notebook tamiri hizmetlerimizle tüm markalarda profesyonel çözümler sunuyoruz. Ekran değişimi, klavye değişimi, fan temizliği, termal macun değişimi, SSD yükseltme ve RAM yükseltme işlemlerini hızlı ve garantili şekilde gerçekleştiriyoruz.',
    features: [
      'Tüm marka laptop tamiri',
      'Ekran ve klavye değişimi',
      'Fan temizliği ve bakım',
      'SSD/RAM yükseltme',
      'Batarya değişimi',
      'Hızlı teslimat',
    ],
    image: 'https://readdy.ai/api/search-image?query=laptop%20repair%20technician%20working%20on%20open%20notebook%20computer%20with%20specialized%20tools%20modern%20service%20center%20clean%20workspace%20professional%20technical%20work%20bright%20studio%20lighting&width=600&height=400&seq=serv4&orientation=landscape',
  },
  {
    id: 5,
    slug: 'format-atma-yazilim',
    icon: 'ri-install-line',
    title: 'Format Atma ve Yazılım',
    shortDesc: 'İşletim sistemi kurulumu ve yazılım hizmetleri',
    description: 'Bilgisayarınız yavaşladı mı? Format atma ve işletim sistemi kurulumu hizmetimizle bilgisayarınızı yeni gibi hale getiriyoruz. Windows kurulumu, driver yüklemeleri, ofis programları ve gerekli yazılımların kurulumunu profesyonelce yapıyoruz.',
    features: [
      'Windows kurulumu',
      'Driver yüklemeleri',
      'Ofis programları kurulumu',
      'Antivirüs kurulumu',
      'Veri yedekleme hizmeti',
      'Sistem optimizasyonu',
    ],
    image: 'https://readdy.ai/api/search-image?query=computer%20screen%20showing%20Windows%20installation%20process%20with%20technician%20hands%20on%20keyboard%20modern%20workspace%20software%20setup%20scene%20clean%20professional%20environment%20bright%20lighting&width=600&height=400&seq=serv5&orientation=landscape',
  },
  {
    id: 6,
    slug: 'ssd-ram-yukseltme',
    icon: 'ri-hard-drive-2-line',
    title: 'SSD / RAM Yükseltme',
    shortDesc: 'Donanım yükseltme ile performans artışı',
    description: 'Bilgisayarınızın performansını artırmak için SSD yükseltme ve RAM yükseltme hizmetlerimizden faydalanın. HDD\'den SSD\'ye geçiş ile bilgisayarınız 5 kat daha hızlı çalışır. RAM kapasitesi artırımı ile çoklu görev performansını yükseltin.',
    features: [
      'SSD yükseltme hizmeti',
      'RAM kapasite artırımı',
      'Veri aktarımı dahil',
      'Uyumlu donanım seçimi',
      'Profesyonel montaj',
      'Performans testi',
    ],
    image: 'https://readdy.ai/api/search-image?query=SSD%20solid%20state%20drive%20and%20RAM%20memory%20modules%20being%20installed%20into%20laptop%20close%20up%20hardware%20upgrade%20scene%20technical%20precision%20work%20clean%20white%20background%20professional%20photography&width=600&height=400&seq=serv6&orientation=landscape',
  },
  {
    id: 7,
    slug: 'ekran-degisimi',
    icon: 'ri-tv-line',
    title: 'Ekran Değişimi',
    shortDesc: 'Laptop ve monitör ekran değişimi',
    description: 'Kırık veya arızalı ekran mı? Laptop ekran değişimi ve monitör tamiri hizmetlerimizle sorununuzu hızlıca çözüyoruz. Orijinal ve uyumlu ekran panelleri ile kaliteli değişim garantisi veriyoruz. Tüm marka ve modellerde ekran tamiri yapıyoruz.',
    features: [
      'Orijinal ekran paneli',
      'Tüm marka ve modeller',
      'Aynı gün değişim',
      'Garanti belgesi',
      'Piksel testi dahil',
      'Uygun fiyat',
    ],
    image: 'https://readdy.ai/api/search-image?query=laptop%20screen%20replacement%20process%20technician%20installing%20new%20LCD%20panel%20close%20up%20technical%20work%20modern%20repair%20shop%20clean%20workspace%20professional%20service%20photography&width=600&height=400&seq=serv7&orientation=landscape',
  },
  {
    id: 8,
    slug: 'fan-temizligi-bakim',
    icon: 'ri-settings-3-line',
    title: 'Fan Temizliği ve Bakım',
    shortDesc: 'Bilgisayar soğutma sistemi bakımı',
    description: 'Bilgisayarınız aşırı ısınıyor mu? Fan temizliği ve termal macun değişimi ile soğutma sistemini yeniliyoruz. Düzenli bilgisayar bakım ile cihazınızın ömrünü uzatın ve performans kaybını önleyin. Oyuncu bilgisayarı tamiri için özel bakım paketlerimiz mevcuttur.',
    features: [
      'Detaylı fan temizliği',
      'Termal macun değişimi',
      'Soğutma sistemi kontrolü',
      'Toz temizliği',
      'Performans testi',
      'Periyodik bakım önerisi',
    ],
    image: 'https://readdy.ai/api/search-image?query=computer%20cooling%20fan%20cleaning%20process%20with%20compressed%20air%20and%20tools%20close%20up%20maintenance%20work%20dust%20removal%20professional%20tech%20service%20clean%20workspace%20bright%20lighting&width=600&height=400&seq=serv8&orientation=landscape',
  },
  {
    id: 9,
    slug: 'kurumsal-teknik-servis',
    icon: 'ri-building-line',
    title: 'Kurumsal Teknik Servis',
    shortDesc: 'Şirketler için özel IT destek hizmetleri',
    description: 'Kurumsal bilgisayar servisi ile işletmenizin IT altyapısını güvence altına alın. Toplu bilgisayar bakım, ağ kurulumu, sunucu yönetimi ve teknik destek hizmetlerimizle iş sürekliliğinizi sağlıyoruz. Özel kurumsal paketler ve anlaşmalar için iletişime geçin.',
    features: [
      'Toplu cihaz bakımı',
      'Öncelikli servis desteği',
      'Yerinde teknik destek',
      'IT danışmanlık hizmeti',
      'Özel fiyatlandırma',
      'Yıllık bakım sözleşmeleri',
    ],
    image: 'https://readdy.ai/api/search-image?query=corporate%20IT%20support%20technician%20servicing%20multiple%20office%20computers%20in%20modern%20business%20environment%20professional%20workspace%20organized%20tech%20setup%20commercial%20service%20photography&width=600&height=400&seq=serv9&orientation=landscape',
  },
];